import React from 'react';
import PropTypes from 'prop-types';

// styles
import styles from './PdpRespBreadcrumbs.scss';

// constants
const DIVIDER = '/';

function PdpRespBreadcrumb({ addDivider, href, onClick, children }) {
    return (
        <li className={styles.breadcrumb}>
            <a className={styles.link} href={href} onClick={onClick} data-tn="pdp-breadcrumb-link">
                {children}
            </a>
            {addDivider && <span className={styles.divider}>{DIVIDER}</span>}
        </li>
    );
}

PdpRespBreadcrumb.propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,

    // options
    addDivider: PropTypes.bool,

    // handlers
    onClick: PropTypes.func,
};

export default PdpRespBreadcrumb;
